import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useShallow } from "zustand/shallow";
import { useUIStore } from "../stores/ui-store";
import { UIState } from "../types/ui-types";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { deleteProduct } from "../api/abstractProduct.api";

const useDeleteAbstractProduct = ({ companyId }) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [bearerToken, toast] = useUIStore(
    useShallow((state: UIState) => [state.bearerToken, state.toastRef])
  );

  const deleteAbstractProduct = async (identifier: string) => {
    const result = await deleteAbstractProductMutation.mutateAsync(identifier);
    return result;
  };

  const deleteAbstractProductMutation = useMutation({
    mutationFn: (identifier: string) =>
      // Assuming there's a deleteCompanyUser function in the API
      deleteProduct(bearerToken as string, companyId, identifier),
    onError: (error) => {
      console.error("Failed to delete abstract product:", error);
      toast?.current?.show({
        severity: "error",
        detail: t("label-abstract-product-delete-failed"),
        life: 3000,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["searchProducts"],
      });
      queryClient.invalidateQueries({
        queryKey: ["abstractProducts"],
      });
      toast?.current?.show({
        severity: "success",
        detail: t("label-abstract-product-deleted"),
        life: 3000,
      });
    },
  });

  const isDeletingAbstractProduct = deleteAbstractProductMutation.isPending;

  return {
    deleteAbstractProduct,
    isDeletingAbstractProduct,
  };
};

export default useDeleteAbstractProduct;
